export default __webpack_public_path__ + "static/media/Logo_DigLog.41b36003.png";